import { TypoCallout } from '@/components/Typography.tsx';
import { Calc, EditText, OpenBook } from '@/components/Icons.tsx';

const KnowledgePower = () => (
  <section className="bg-[#422933] pt-24 pb-14 md:pb-24 px-4 text-center">
    <h3 className="font-primary text-title md:text-heroTitle !font-extraBold">
        Knowledge is power
    </h3>
    <strong className="block font-primary text-body font-bold md:text-heroSubtitle text-[#D3B6AD] mt-4">
        Did you know that the questions on the digital SAT <br />
        can be categorized into 43 different question types?
    </strong>

    <div className="flex justify-center flex-wrap gap-6 py-6 md:py-12">
      {Object.keys(TYPE).map((type) => <Card key={type} type={type as keyof typeof TYPE} />)}
    </div>

    <h3 className="font-primary text-title md:text-heroTitle font-extraBold mt-4 md:mt-8">
        A <strong className="text-primary">game plan</strong> is confidence
    </h3>
    <strong className="block font-primary text-body font-bold md:text-heroSubtitle text-[#D3B6AD] mt-4">
        Winning students know what’s coming and <br />
        what to do when they see it.
    </strong>
    <TypoCallout
      className="block text-[#D3B6AD] md:text-body !font-semibold my-10 mx-auto max-w-[33rem] md:max-w-[38rem]"
    >
        The SATPrac Complete and Concierge packages include access to video
        tutorials that coach you through the 3 key steps to dominating the SAT.
        Each video tutorial is like a private lesson with Idiot Tutor Mark Anestis.
    </TypoCallout>
  </section>
);

const Card = ({ type }: { type: keyof typeof TYPE }) => {
  const { Icon, title, count } = TYPE[type];
  return (
    <div className="flex flex-col items-center gap-3 p-4 rounded-2xl bg-gradient-to-b from-[#FEE7E1] to-[#F8DDD6]">
      <strong className="uppercase text-body font-primary font-semibold leading-normal mb-0.5 text-[#422933]">
        {title}
      </strong>
      <div
        className="flex items-center justify-center rounded-3xl w-16 h-16 bg-gradient-to-b from-[#420D0F] to-[#C1272D]"
      >
        <Icon className="text-[#E1CDC3]" />
      </div>
      <span className="text-callout leading-normal text-[#422933]">{count} Question Types</span>
    </div>
  );
};

const TYPE = {
  MATH: { Icon: Calc, title: 'Math', count: 25 },
  READING: { Icon: OpenBook, title: 'Reading', count: 13 },
  GRAMMAR: { Icon: EditText, title: 'Grammar', count: 5 },
};

export default KnowledgePower;
